import React from 'react';
import CareerDiscovery from '../components/CareerDiscovery';
import './HomePage.css';

const HomePage = ({ loggedIn, email, user }) => {
    // Extract userId from user profile or use fallback
    const userId = user?.profile?.sub || user?.profile?.userId || '018923e0-3102-44e4-9330-55789aa816a3';

    return (
        <div className="homepage-container">
            {loggedIn && (
                <CareerDiscovery email={email} userId={userId} />
            )}
        </div>
    );
};

export default HomePage;
